import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// https://github.com/remix-run/react-router/blob/main/docs/getting-started/tutorial.md
import {
  HashRouter,
  Route,
  Routes
} from "react-router-dom";
import Home from './components/home/Home';
import RailcarStorage from './components/railcar-storage/RailcarStorage';
import Transloading from './components/transloading/Transloading';
import FindProperty from './components/property/Property';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import config from './config';
import ContactUs from './components/contact-us/ContactUs';
import version from '../package.json'
import { AuthContextProvider } from './context/useAuth';
import { ScreenSizeProvider } from './context/useScreenSize';
import NavBar from './components/nav-bar/NavBar';


console.log(process.env.NODE_ENV);
console.log("GeoConnect Version: " + JSON.stringify(version.version));

const Providers = ({ children }: React.PropsWithChildren) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={config.reCaptchaKey}
    >
      <AuthContextProvider>
        <ScreenSizeProvider>
          {children}
        </ScreenSizeProvider>
      </AuthContextProvider>
    </GoogleReCaptchaProvider>
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Providers>
      <HashRouter>
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="railcar-storage"
            element={
              <RailcarStorage webMapId={config.railcarStorage.webMapId} />
            }
          />
          <Route path="transloading" element={<Transloading webMapId={config.transloading.webMapId} />} />
          <Route path="find-property" element={<FindProperty webMapId={config.property.webMapId} />} />
          <Route path="contact-us" element={<ContactUs />} />
        </Routes>
      </HashRouter>
    </Providers>
  </React.StrictMode >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
